import React from "react";
import {QuickbetListData} from "../helpers/helpers";
import {Card, CardHeader, CardContent, List, ListItem} from "framework7-react";

interface QuickbetProps {
    data: QuickbetListData[];
    openModal: (type: string) => void;
}
const QuickbetListPage: React.FC <QuickbetProps> = ({data, openModal}) => {
    return (
            <Card className="data-table data-table-init">
                <CardHeader>
                   <div className='text-align-center'>Quickbet</div>
                </CardHeader>
                <CardContent padding={false}>
                    <List dividersIos mediaList outlineIos strongIos>

                        {
                            data.map((item, index) => {

                                return(
                                    <ListItem
                                        link="#"
                                        title={item.title}
                                        after={item.events.length}
                                        subtitle={item.preview_title}
                                        text={item.description}
                                    >
                                        <img
                                            slot="media"
                                            style={{ borderRadius: '8px' }}
                                            src={item.preview_img}
                                            width="50"
                                        />
                                    </ListItem>
                                );
                            })
                        }
                    </List>
                </CardContent>
            </Card>
    )
};
export default QuickbetListPage;